/** @jsx jsx */
import { jsx, css, Global } from '@emotion/react';
import React, { useEffect } from 'react';
import i18n from '@/utils/i18n';
import { LangKey as awxLangKey } from '@airwallex/global';
import { ThemeProvider } from '@airwallex/theme';
import { getLanguage } from '@/utils/language';
import { StoreProvider } from '@/providers/storeProvider';
import Route from './pages';
import { airTracker } from './utils/airTracker';
import { useFeatureGate } from '@statsig/react-bindings';
import { StoreProviderV2 } from './pages/paybylinkV2/providers/storeProvider';
import StatsigProviderV2 from './pages/paybylinkV2/providers/statsigProvider';

export const COMPONENT_NAME_V2 = 'PBL_FE_V2';

const App: React.FC = () => {
  useEffect(() => {
    const langKey = getLanguage();
    airTracker.updateCommonData({ lang: langKey });
    i18n.changeLanguage(langKey);
  }, []);

  return (
    <StatsigProviderV2>
      <AppWrapper />
    </StatsigProviderV2>
  );
};

const AppWrapper = () => {
  const { language } = i18n;
  const enablePblFeV2 = useFeatureGate('enable-pbl-fe-v2').value;
  return enablePblFeV2 ? (
    <React.Fragment>
      <ThemeProvider langKey={language as awxLangKey}>
        <StoreProviderV2>
          <Global
            styles={css`
              input {
                font-family: AxLLCircular, Helvetica, Arial, sans-serif;
              }
              @font-face {
                font-family: AxLLCircular;
                src: url(https://checkout.airwallex.com/fonts/CircularXXWeb/CircularXXWeb-Regular.woff2);
                font-weight: 400;
                font-style: normal;
              }
              @font-face {
                font-family: AxLLCircular;
                src: url(https://checkout.airwallex.com/fonts/CircularXXWeb/CircularXXSub-BoldSubset.woff2);
                font-weight: 500;
                font-style: normal;
              }
            `}
          />
          <Route />
        </StoreProviderV2>
      </ThemeProvider>
    </React.Fragment>
  ) : (
    <React.Fragment>
      <ThemeProvider langKey={language as awxLangKey}>
        <StoreProvider>
          <Global
            styles={css`
              input {
                font-family: AxLLCircular, Helvetica, Arial, sans-serif;
              }
              @font-face {
                font-family: AxLLCircular;
                src: url(https://checkout.airwallex.com/fonts/CircularXXWeb/CircularXXWeb-Regular.woff2);
                font-weight: 400;
                font-style: normal;
              }
              @font-face {
                font-family: AxLLCircular;
                src: url(https://checkout.airwallex.com/fonts/CircularXXWeb/CircularXXSub-BoldSubset.woff2);
                font-weight: 500;
                font-style: normal;
              }
            `}
          />
          <Route />
        </StoreProvider>
      </ThemeProvider>
    </React.Fragment>
  );
};
export default App;
